import router from "@/router";

export default function auth({next, store}) {
    // console.log(store.getters.auth);
    let token = localStorage.getItem('token');
    if (!token || !store.getters.auth) {
        store.dispatch('logout_user');
        router.push({
            name: "Login"
        });
    }
    return next()
}
